import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const TenableInfraMappingForm = forwardRef(function TenableInfraMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { assetId, assetName } = props.record;
      return [{id: assetId, name: `${assetName} (${assetId})`}]
    }
    return [];
  });
  const [ loading, setLoading ] = useState(true);

  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects);
    }).catch(() => {
      message.error('Problem fetching scans');
    }).finally(()=>{
      setLoading(false);
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { assetId } = config;
    const assetName = find(projects, (obj) => obj.id === assetId)?.name;

    return ({
      assetId,
      assetName: `${assetName} (${assetId})`,
    });
  }

  const extraFields = useMemo(() => ([
    {
      name: 'assetId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Tenable Infrastructure Scans (ID)',
      options: projects.map(option => {
        const { label = `${option.name} (${option.id})`, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      loading,
      props: {
        autoFocus: true
      }
    }
  ]), [projects,loading]);

  return (
    <GenericMappingForm
      title="Map Tenable Infrastructure Scans"
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      formDefaultValues={initialValues}
      {...props}
    />
  )
})

export default TenableInfraMappingForm;
